import {PublicLayout, BasicLayout, ManageRouterLayout} from '@/layout'
import { RouteRecordRaw } from 'vue-router'

// 权限菜单
const roleRoutes:Array<RouteRecordRaw> = [
  {
    path: '/manage',
    name: 'manage',
    redirect: '/manage/dashboard',
    component: BasicLayout,
    children: [
      // 数据
      {
        path: '/manage/dashboard',
        name: 'manage-dashboard',
        redirect: '/manage/dashboard/index',
        component: ManageRouterLayout,
        meta: {
          title: '数据',
          keepAlive: true,
          icon: 'icon-yingxiao'
        },
        children: [
          {
            path: '/manage/dashboard/index',
            name: 'manage-dashboard-index',
            component: () => import('@/views/manage/dashboard/DashboardIndex.vue'),
            meta: { title: '数据展示', keepAlive: true, permission: ['manage-dashboard-index'] }
          },
          {
            path: '/manage/report/vacate',
            name: 'manage-report-vacate',
            component: () => import('@/views/manage/dashboard/VacateReport.vue'),
            meta: { title: '请假报表', keepAlive: true, permission: ['manage-report-vacate'] }
          },
          {
            path: '/manage/report/student',
            name: 'manage-report-student',
            component: () => import('@/views/manage/dashboard/StudentMealReport.vue'),
            meta: { title: '学生就餐统计', keepAlive: true, permission: ['manage-report-student'] }
          },
          {
            path: '/manage/report/class',
            name: 'manage-report-class',
            component: () => import('@/views/manage/dashboard/ClassMealReport.vue'),
            meta: { title: '班级就餐统计', keepAlive: true, permission: ['manage-report-class'] }
          },
          {
            path: '/manage/calendar/index',
            name: 'manage-calendar-index',
            component: () => import('@/views/manage/dashboard/CalendarConfig.vue'),
            meta: { title: '就餐日历', keepAlive: true, permission: ['manage-calendar-index'] }
          },
          {
            path: '/manage/company-report/vacate',
            name: 'manage-company-report-vacate',
            component: () => import('@/views/manage/company/VacateReport.vue'),
            meta: { title: '请假报表', keepAlive: true, permission: ['manage-company-report-vacate'] }
          },
          {
            path: '/manage/company-report/student',
            name: 'manage-company-report-student',
            component: () => import('@/views/manage/company/StudentMealReport.vue'),
            meta: { title: '学生就餐统计', keepAlive: true, permission: ['manage-company-report-student'] }
          },
          {
            path: '/manage/company-report/class',
            name: 'manage-company-report-class',
            component: () => import('@/views/manage/company/ClassMealReport.vue'),
            meta: { title: '班级就餐统计', keepAlive: true, permission: ['manage-company-report-class'] }
          },
        ]
      },
      
      // 公司
      {
        path: '/manage/company',
        name: 'manage-company',
        redirect: '/manage/company/list',
        component: ManageRouterLayout,
        meta: {
          title: '公司',
          keepAlive: true,
          icon: 'icon-shengchanqiye'
        },
        children: [
          {
            path: '/manage/company/list',
            name: 'manage-company-list',
            component: () => import('@/views/manage/company/CompanyList.vue'),
            meta: { title: '公司管理', keepAlive: true, permission: ['manage-company-list'] }
          }
        ]
      },

      // 学校
      {
        path: '/manage/school',
        name: 'manage-school',
        redirect: '/manage/school/list',
        component: ManageRouterLayout,
        meta: {
          title: '学校',
          keepAlive: true,
          icon: 'icon-xuexiao1'
        },
        children: [
          {
            path: '/manage/school/list',
            name: 'manage-school-list',
            component: () => import('@/views/manage/school/SchoolList.vue'),
            meta: { title: '学校管理', keepAlive: true, permission: ['manage-school-list'] }
          },
          {
            path: '/manage/school/company',
            name: 'manage-school-company',
            component: () => import('@/views/manage/school/CompanySchoolList.vue'),
            meta: { title: '关联学校', keepAlive: true, permission: ['manage-school-company'] }
          },
          {
            path: '/manage/school/grade',
            name: 'manage-school-grade',
            component: () => import('@/views/manage/school/GradeList.vue'),
            meta: { title: '级部管理', keepAlive: true, permission: ['manage-school-grade'] }
          },
          {
            path: '/manage/school/class',
            name: 'manage-school-class',
            component: () => import('@/views/manage/school/GradeClassList.vue'),
            meta: { title: '班级管理', keepAlive: true, permission: ['manage-school-class'] }
          },
          {
            path: '/manage/school/teacher',
            name: 'manage-school-teacher',
            component: () => import('@/views/manage/school/TeacherList.vue'),
            meta: { title: '教师管理', keepAlive: true, permission: ['manage-school-teacher'] }
          }
        ]
      },

      // 学生
      {
        path: '/manage/student',
        name: 'manage-student',
        redirect: '/manage/student/list',
        component: ManageRouterLayout,
        meta: {
          title: '学生',
          keepAlive: true,
          icon: 'icon-xuesheng1'
        },
        children: [
          {
            path: '/manage/student/list',
            name: 'manage-student-list',
            component: () => import('@/views/manage/student/StudentList.vue'),
            meta: { title: '学生管理', keepAlive: true, permission: ['manage-student-list'] }
          },
          {
            path: '/manage/student/regist',
            name: 'manage-student-regist',
            component: () => import('@/views/manage/student/RegistMealList.vue'),
            meta: { title: '报名管理', keepAlive: true, permission: ['manage-student-regist'] }
          },
          {
            path: '/manage/student/vacate',
            name: 'manage-student-vacate',
            component: () => import('@/views/manage/student/VacateList.vue'),
            meta: { title: '请假管理', keepAlive: true, permission: ['manage-student-vacate'] }
          },
          {
            path: '/manage/student/offschool',
            name: 'manage-student-offschool',
            component: () => import('@/views/manage/student/OffSchoolList.vue'),
            meta: { title: '离校管理', keepAlive: true, permission: ['manage-student-offschool'] }
          }
        ]
      },

      // 文章
      {
        path: '/manage/article',
        name: 'manage-article',
        redirect: '/manage/article/list',
        component: ManageRouterLayout,
        meta: {
          title: '文章',
          keepAlive: true,
          icon: 'icon-16'
        },
        children: [
          {
            path: '/manage/article/list',
            name: 'manage-article-list',
            component: () => import('@/views/manage/artiles/ArtileList.vue'),
            meta: { title: '文章管理', keepAlive: true, permission: ['manage-article-list'] }
          },
          {
            path: '/manage/article/type',
            name: 'manage-article-type',
            component: () => import('@/views/manage/artiles/ArticleType.vue'),
            meta: { title: '文章类型', keepAlive: true, permission: ['manage-article-type'] }
          }
        ]
      },
      // 用户
      {
        path: '/manage/user',
        name: 'manage-user',
        redirect: '/manage/admin/list',
        component: ManageRouterLayout,
        meta: {
          title: '用户',
          keepAlive: true,
          icon: 'icon-yonghu1'
        },
        children: [
          {
            path: '/manage/user/admins',
            name: 'manage-user-admins',
            component: () => import('@/views/manage/user/SAdminList.vue'),
            meta: { title: '超级管理员', keepAlive: true, permission: ['manage-user-admins'] }
          },
          {
            path: '/manage/user/companys',
            name: 'manage-user-companys',
            component: () => import('@/views/manage/user/CompanyUser.vue'),
            meta: { title: '公司用户', keepAlive: true, permission: ['manage-user-companys'] }
          },
          {
            path: '/manage/user/schools',
            name: 'manage-user-schools',
            component: () => import('@/views/manage/user/SchoolUser.vue'),
            meta: { title: '学校管理员', keepAlive: true, permission: ['manage-user-schools'] }
          },
          {
            path: '/manage/user/canteens',
            name: 'manage-user-canteens',
            component: () => import('@/views/manage/user/CanteenUser.vue'),
            meta: { title: '食堂管理员', keepAlive: true, permission: ['manage-user-canteens'] }
          },
          {
            path: '/manage/user/list',
            name: 'manage-user-list',
            component: () => import('@/views/manage/user/UserList.vue'),
            meta: { title: '微信用户', keepAlive: true, permission: ['manage-user-list'] }
          }
        ]
      },
      // 权限
      {
        path: '/manage/role',
        name: 'manage-role',
        redirect: '/manage/role/list',
        component: ManageRouterLayout,
        meta: {
          title: '权限',
          keepAlive: true,
          icon: 'icon-quanxian'
        },
        children: [
          {
            path: '/manage/role/list',
            name: 'manage-role-list',
            component: () => import('@/views/manage/roles/RoleList.vue'),
            meta: { title: '角色管理', keepAlive: true, permission: ['manage-role-list'] }
          },
          {
            path: '/manage/rule/list',
            name: 'manage-rule-list',
            component: () => import('@/views/manage/roles/PermissionList.vue'),
            meta: { title: '权限管理', keepAlive: true, permission: ['manage-rule-list'] }
          }
        ]
      },
      // 系统
      {
        path: '/manage/system',
        name: 'manage-system',
        redirect: '/manage/system/config',
        component: ManageRouterLayout,
        meta: {
          title: '系统',
          keepAlive: true,
          icon: 'icon-icon02'
        },
        children: [
          {
            path: '/manage/system/config',
            name: 'manage-system-config',
            component: () => import('@/views/manage/system/SysConfig.vue'),
            meta: { title: '系统配置', keepAlive: true, permission: ['manage-system-config'] }
          },
          {
            path: '/manage/log/list',
            name: 'manage-log-list',
            component: () => import('@/views/manage/system/LogList.vue'),
            meta: { title: '操作日志', keepAlive: true, permission: ['manage-log-list'] }
          },
          {
            path: '/manage/student/import',
            name: 'manage-student-import',
            component: () => import('@/views/manage/system/ImportStudent.vue'),
            meta: { title: '学生导入', keepAlive: true, permission: ['manage-student-import'] }
          }
        ]
      }
    ]
  }
]

// 通用菜单
const normalRoutes:Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    redirect: '/manage',
    children: []
  },
  {
    path: '/manage',
    name: 'manage',
    component: BasicLayout,
    children: []
  },
  {
    path: '/manage',
    component: PublicLayout,
    redirect: '/manage/login',
    children: [
      {
        path: '/manage/login',
        name: 'manage-login',
        component: () => import('@/views/public/UserLogin.vue'),
        meta: { title: '登录' }
      },
      {
        path: '/manage/forget',
        name: 'manage-forget',
        component: () => import('@/views/public/UserForget.vue'),
        meta: { title: '忘记账号' }
      },
      {
        path: '/manage/forgetpsw',
        name: 'manage-forgetpsw',
        component: () => import('@/views/public/UserForgetPsw.vue'),
        meta: { title: '忘记密码' }
      }
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: BasicLayout,
    redirect: '/account/index',
    children: [
      {
        path: '/account/index',
        name: 'account-index',
        redirect: '/account/info',
        component: () => import('@/views/manage/account/AccountIndex.vue'),
        meta: { title: '账号管理', keepAlive: true },
        children: [
          {
            path: '/account/info',
            name: 'account-info',
            component: () => import('@/views/manage/account/UserInfo.vue'),
            meta: { title: '我的信息', keepAlive: true }
          },
          {
            path: '/account/safe',
            name: 'account-safe',
            component: () => import('@/views/manage/account/SafeInfo.vue'),
            meta: { title: '安全设置', keepAlive: true }
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/public/exception/NotFound.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/public/exception/NotFound.vue')
  }
]

const hasHiddenChildren = []
export {roleRoutes, normalRoutes,hasHiddenChildren}